const LoadingIcon = () => {
    return (
        <div className="flex items-center justify-center h-screen bg-gray-900">
            <div className="w-12 h-12 border-4 border-t-4 border-gray-200 rounded-full animate-spin"></div>
        </div>
    )
}

export default LoadingIcon;